import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="flash-message"
export default class extends Controller {
  static targets = [];
  static values = { timeout: { type: Number, default: 5000 } };

  connect() {
    // Auto-dismiss after timeout
    this.timeoutId = setTimeout(() => {
      this.dismiss();
    }, this.timeoutValue);

    // Add click handler for manual dismiss
    this.element.addEventListener("click", this.dismiss.bind(this));

    // Add close button if it doesn't exist
    this.addCloseButton();
  }

  disconnect() {
    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
    }
  }

  dismiss() {
    // Add fade out animation
    this.element.style.transition =
      "opacity 0.3s ease-out, transform 0.3s ease-out";
    this.element.style.opacity = "0";
    this.element.style.transform = "translateY(-10px)";

    // Remove element after animation
    setTimeout(() => {
      if (this.element.parentNode) {
        this.element.parentNode.removeChild(this.element);
      }
    }, 300);
  }

  addCloseButton() {
    // Check if close button already exists
    if (this.element.querySelector(".flash-close-btn")) {
      return;
    }

    // Create close button
    const closeButton = document.createElement("button");
    closeButton.className =
      "flash-close-btn ml-auto pl-3 text-current hover:opacity-70 transition-opacity";
    closeButton.innerHTML = `
      <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
      </svg>
    `;
    closeButton.setAttribute("type", "button");
    closeButton.setAttribute("aria-label", "Close message");

    // Find the flex container and add the close button
    const flexContainer = this.element.querySelector(".flex");
    if (flexContainer) {
      flexContainer.appendChild(closeButton);
    }
  }
}
